import React from "react";
import "../OrderComponents/OrderTabs.css";
import { useState } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import api from "../../seller-apis/api";
import { displayRazorpay } from "../../utilities/razorPay";
import { useAlert } from "react-alert";
import { Actions } from "../../Actions/Actions";

// Global flag to track if wallet plans API has been called in this session
var walletPlansApiCalled = false;

const UnlockLeadsPopup = ({ show, handleClose, leadId }) => {
  const walletAmt = useSelector(state => state.ActionReducer.WalletAmount);
  const [ballence, setBallance] = useState(6000);
  const [currWalletBal, setCurrWalletBal] = useState(6000);
  const [proceed, setProceed] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(100);
  const [leadAmt, setLeadAmt] = useState(0);
  const dispatch = useDispatch();
  const Alert = useAlert();
  const containerStyle = {
    backgroundSize: "21%",
  };
  const badgeAmt = [500, 1000, 2000];
  // const changeBallence = (amt) => {
  //   setBallance(amt);
  // };

  // useEffect(() => {
  //   if (walletPlansApiCalled) {
  //     return;
  //   }
    
  //   walletPlansApiCalled = true;
    
  //   api.customerLeads.getWalletPlans().then((data) => {
  //     console.log("Plans", data);
  //     setPlans(data?.data?.records || []);
  //     const res = data?.data?.records?.filter((item) => item?.best === true);
  //     setSelectedPlan(res[0]);
  //   }
  //   );
  // }, [])

  useEffect(() => {
    setShowSuccess(false);

    // unlock leads feature Sl-3133
    api.customerLeads.getLeadPrice().then((data) => {
      setLeadAmt(data?.data?.[0]?.price);
    });
  }, [show])


  const addWalletAmt = (amt) => {
    // let totalAmt = parseInt(amt) + ((parseInt(amt) * 18) / 100);
    const txType = "lead-unlock";
    displayRazorpay(amt, txType, leadId).then((data) => {
      if (data == "Amount exceeds maximum amount allowed." || data == "Product not found in your catalog") {
        Alert.error(data);
      }
      else {
        // setShowSuccess(true);
        Alert.success("Lead unlocked successfully")
        handleClose();
        // getAmount();
        // setTimeout(() => {
        //   handleClose();
        // }, 1000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  const getAmount = () => {
    api.customerLeads.getWalletBallence().then((data) => {
      setCurrWalletBal(data?.data?.record?.wallet?.currentBal);
      Actions.upadteWalletAmount(dispatch, data?.data?.record?.wallet || []);
    });
    //SL-710
    window.location.reload();
  }
  const handleInputChange = (e) => {
    // Allow only numbers (0-9) in the input
    const value = e.target.value.replace(/[^0-9]/g, '');
    setBallance(value);
  };

  const handlePlanClick = (item) => {
    console.log("item", item);
    setSelectedPlan(item)
  }

  const iconsForPlans = {
    "50000": <i className="bi bi-calendar4"></i>,
    "30000": <i className="bi bi-clock"></i>,
    "18000": <i className="bi bi-patch-check"></i>
  }
  return (
    <Modal className="unlockLead-modal" centered show={show} onHide={handleClose}>
      <Modal.Body>
        <div className="white-bg wallet-main">
          <div className="wallet-container" style={containerStyle}>
            <div className="close-button-wallet" onClick={() => handleClose()}>&times;</div>
            {!showSuccess ?
              <div className="lead-subscription-popup">
                <div className="title">Unlock Lead</div>
              
                  <div className="sp-plans-features-cntn">
                    <div className="row">
                      <div className="col-12">
                        <div className="sp-plan-feature"><i className="bi bi-telephone"></i> Direct phone number & email of the buyer</div>
                      </div>
                      <div className="col-12">
                        <div className="sp-plan-features"><i className="bi bi-geo-alt"></i> Exact location details</div>
                      </div>
                      <div className="col-12">
                        <div className="sp-plan-features"><i className="bi bi-lightning"></i> Respond before competitors do</div>
                      </div>
                    </div>
                  </div>
                <div className="wallet-button" onClick={()=>{addWalletAmt(leadAmt)}}>
                  <i className="bi bi-check-circle-fill"></i> Unlock now for &#8377; {leadAmt}
                      <OverlayTrigger
                                                key="lead_subs"
                                                placement="top"
                                                overlay={
                                                    <Tooltip id={`tooltip-lead_subs`} className="fs-14 order_page_tooltip">
                                                        <p className='fs-12 f-500 order_page_tooltip_1'> Including 18% GST</p>
                                                    </Tooltip>
                                                }
                                                >
                                                <i class="fa fa-info-circle" aria-hidden="true" style={{marginLeft:"5px"}}></i>
                      </OverlayTrigger>
                 </div>
              </div>
              :
              <div className="inner-data d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                <div className="text-center">
                  Lead unlocked successfully
                </div>
              </div>
            }
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UnlockLeadsPopup;
